import { ProjectsService } from "@/common/api.service";
import {
  FETCH_PROJECTS,
  FETCH_PROJECT,
  FETCH_PROJECT_TYPES,
  FETCH_PROJECT_HISTORY,
  ADD_PROJECT,
  SAVE_PROJECT,
  SEND_PROJECT,
  RESEND_PROJECT, FETCH_PROJECT_MAIN_INFO
} from "./actions.type";

import {
  FETCH_PROJECT_START,
  FETCH_PROJECT_END,
  FETCH_PROJECTS_START,
  FETCH_PROJECTS_END,
  UPDATE_PROJECT_IN_LIST,
  ADD_PROJECT_START,
  ADD_PROJECT_END,
  ADD_PROJECT_ERROR,
  SAVE_PROJECT_START,
  SAVE_PROJECT_END,
  SAVE_PROJECT_ERROR,
  FETCH_PROJECTS_ERROR, FETCH_PROJECT_MAIN_INFO_START, FETCH_PROJECT_MAIN_INFO_END, FETCH_PROJECTS_MAIN_INFO_ERROR
} from "./mutations.type";

const state = {
  project: {
    ID: "",
    UF_NUMBER: "",
    UF_NAME: "",
    TITLE_NAME: "",
    COUNT_NEW_MESSAGE: "",
    UF_HELP: {
      FIELDS: {},
      NEW_PROJECT: {},
      SCENARIO: {},
      STATUS_NAME: ""
    },
    ARR1: [],
    ARR2: [],
    ARR3: [],
    BUDGET: {
      BUDGET_ARTICLE_ID: [
        {
          UF_BUDGET_ARTICLE_NAME: "",
          UF_BUDGET_ARTICLE_ID: "",
          UF_BUDGET_ARTICLE_SECTION_NAME: "",
          IS_ZARPLATA_ZAIM_BLOCK: "",
          IS_ZARPLATA_SOFIN_BLOCK: "",
          IS_JOB_ZAIM_BLOCK: "",
          IS_JOB_SOFIN_BLOCK: "",
          IS_MATERIAL_ZAIM_BLOCK: "",
          IS_MATERIAL_SOFIN_BLOCK: "",
          IS_OBORUD_ZAIM_BLOCK: "",
          IS_OBORUD_SOFIN_BLOCK: ""
        }
      ],
      items: [
        {
          UF_ZARPLATA_ZAIM: "",
          UF_ZARPLATA_SOFIN: "",
          UF_JOB_ZAIM: "",
          UF_JOB_SOFIN: "",
          UF_MATERIAL_ZAIM: "",
          UF_MATERIAL_SOFIN: "",
          UF_OBORUD_ZAIM: "",
          UF_OBORUD_SOFIN: "",
          UF_ITOGO_ZAIM: "",
          UF_ITOGO_SOFIN: ""
        }
      ]
    },
    BUDGET_YEAR: {
      YearTwoLine: "",
      yearStart: 0,
      yearEnd: 0,
      YearBlockInfo: [
        {
          IS_JOB_SOFIN_BLOCK: 0,
          IS_JOB_ZAIM_BLOCK: 0,
          IS_MATERIAL_SOFIN_BLOCK: 0,
          IS_MATERIAL_ZAIM_BLOCK: 0,
          IS_OBORUD_SOFIN_BLOCK: 0,
          IS_OBORUD_ZAIM_BLOCK: 0,
          IS_ZARPLATA_SOFIN_BLOCK: 0,
          IS_ZARPLATA_ZAIM_BLOCK: 0
        }
      ],
      items: [
        {
          ID: 0,
          UF_IS_ALREADY: 0,
          UF_ITOGO_SOFIN: 0,
          UF_ITOGO_ZAIM: 0,
          UF_JOB_SOFIN: 0,
          UF_JOB_ZAIM: 0,
          UF_MATERIAL_SOFIN: 0,
          UF_MATERIAL_ZAIM: 0,
          UF_OBORUD_SOFIN: 0,
          UF_OBORUD_ZAIM: 0,
          UF_PROJECT_ID: 0,
          UF_YEAR: 0,
          UF_ZARPLATA_SOFIN: 0,
          UF_ZARPLATA_ZAIM: 0
        }
      ]
    },
    CONTACTS: [
      {
        UF_COMPANY_ID: "",
        UF_EMAIL1: "",
        UF_EMAIL2: "",
        UF_FIRST_NAME: "",
        UF_IS_LIZING_ADD: "",
        UF_IS_LIZING_CONTACT: "",
        UF_IS_REG_F_CONTACT: "",
        UF_NAME: "",
        UF_PHONE1: "",
        UF_PHONE2: "",
        UF_POSITION: "",
        UF_PROJECT_ID: "",
        UF_SECOND_NAME: ""
      }
    ],
    CONTACTS_REGION_FOND: [
      {
        UF_COMPANY_ID: "",
        UF_EMAIL1: "",
        UF_EMAIL2: "",
        UF_FIRST_NAME: "",
        UF_IS_LIZING_ADD: "",
        UF_IS_LIZING_CONTACT: "",
        UF_IS_REG_F_CONTACT: "",
        UF_NAME: "",
        UF_PHONE1: "",
        UF_PHONE2: "",
        UF_POSITION: "",
        UF_PROJECT_ID: "",
        UF_SECOND_NAME: ""
      }
    ],
    SUBCONTRACTORS: [
      {
        ID: "",
        UF_NAME: "",
        UF_PROJECT_ID: "",
        UF_SCOPE_OF_WORK: "",
        UF_SUMM_WORK: "",
        UF_TYPE_COAUTHOR: ""
      }
    ],
    INDICATORS: {
      yearStart: 0,
      yearEnd: 0,
      INDICATORS_ID: [],
      items: [
        {
          ID: 0,
          UF_INDICATORS_ID: 0,
          UF_INDICATORS_VALUE: 0,
          UF_INDICATORS_YEAR: 0,
          UF_PROJECT_ID: 0
        }
      ]
    },
    FINANCIAL_INDICATORS: {
      yearStart: 0,
      yearEnd: 0,
      INDICATORS_ID: [],
      items: [
        {
          ID: 0,
          UF_FINANCIAL_INDICATORS_ID: 0,
          UF_INDICATORS_VALUE: 0,
          UF_INDICATORS_YEAR: 0,
          UF_PROJECT_ID: 0
        }
      ]
    },
    BANK_GUARANTEE: {},
    DIGITAL_SOLUTION: {
      items: [
        {
          ID: 0,
          UF_COUNT: 0,
          UF_DESCRIPTION: "",
          UF_PROJECT_ID: 0,
          UF_VID_GROUP_ID: null,
          UF_VID_ID: null
        }
      ]
    },
    SYSTEM_INTEGRATOR: {
      items: [
        {
          ID: 0,
          UF_NAME: "",
          UF_PRICE: 0,
          UF_PROJECT_ID: 0
        }
      ]
    },
    MAIN_COVER: {
      MAIN_COVER_ID: []
    },
    UF_SUM_REQUEST: "",
    COMPANY: {
      UF_COMPANY_ID: "",
      NAME: ""
    },
    STATUS: {
      UF_STATUS_ID: "",
      NAME: ""
    },
    SCENARIO: {
      HEAD_BUTTON: {
        IS_VIEW_BUTTON_DOC_ES: 0,
        IS_VIEW_BUTTON_SEND_PROJECT: 0,
        IS_ACTIVE_BUTTON_SEND_PROJECT: 0,
        ACTION: ""
      },
      STATUS_BAR: {
        TEXT_STATUS_BEFORE: "",
        TEXT_HELP_BEFORE: "",
        LIST_STATUS_BAR: [],
        TEXT_HELP_AFTER: ""
      },
      ORG_LIST: {
        LIST: [],
        IS_BLOCK: 0,
        ID_SET: 0
      },
      IS_VIEW_NOTIFICATION: true,
      NOTIFICATION: "",
      STAGE_PROJECT: []
    },
    INTELECTUAL_RESULT: [
      {
        ID: "",
        UF_COUNTRY_ID: "",
        UF_FORMA: "",
        UF_NAME: "",
        UF_OWNER: "",
        UF_PLAN_DATE: "",
        UF_PROJECT_ID: ""
      }
    ],
    UF_OKPD_CLASS_ID: "",
    UF_OKPD_PODCLASS_ID: "",
    UF_OKPD_GROUP_ID: "",
    UF_ANNOTATION: "",
    UF_RESULT_NATURAL: "",
    UF_IS_ALL_ZAIM_PR: "",
    UF_ALL_SUMM_PROCENT: "",
    UF_OLD_KRVART: "",
    UF_DATE_CREATE: "",
    UF_TIMESTAMP_X: "",
    UF_CREATED_BY: "",
    UF_MODIFIED_BY: "",
    UF_IS_ACTIVE: "",
    UF_ACTIVE_FROM: "",
    UF_ACTIVE_TO: "",
    UF_SORT: "",
    UF_AUTHOR_ID: "",
    UF_IS_LISING: "",
    UF_STATUS_ID: "",
    UF_COMPANY_ID: "",
    UF_MANAGER_ID: "",
    UF_MANAGER_OSP: "",
    UF_MANAGER_OSP_NAME: "",
    UF_SUPPORT_PROG_ID: "",
    CHANGE_PROGRAM_LIST: [],
    OTHER_SOURCE_FINANCE: {
      UF_OTHER_SOURCE_ID: [],
      items: [
        {
          ID: 0,
          UF_COUNTRY_ID: "",
          UF_OTHER_SOURCE_ID: "",
          UF_PROJECT_ID: "",
          UF_SOURCE: "",
          UF_TARGET: "",
          UF_VALUE: "",
          UF_YEAR: ""
        }
      ]
    },
    UF_INDUSTRY_ID: "",
    UF_SUB_INDUSTRY_ID: "",
    UF_MONTH_RETURN: "",
    UF_SCIENCE_ID: "",
    UF_PRODUCTION_ID: "",
    UF_OKVED_ID: "",
    UF_POTENTIAL: "",
    UF_SALE: "",
    UF_TECHNICAL_LEVEL: "",
    UF_MAIN_STAGES: "",
    UF_AVAILABLE_RESULTS: "",
    UF_REGION_ID: "",
    UF_IS_MONOGOROD: "",
    UF_MONOGOROD_ID: "",
    UF_CITY: "",
    UF_IMPORT_PLAN_ID: "",
    UF_CODE_PRODUCTS: "",
    UF_IS_RESIDENT_OEZ: "",
    UF_PERIOD_START: "",
    UF_SALES_VOLUME: "",
    UF_IS_EXPORT_PRODUCT: "",
    UF_EXPORT_COUNTRY_ID: [],
    UF_NUMBER_JOBS: "",
    UF_TAX_REVENUE: "",
    UF_REQ_INTELLECTUAL: "",
    UF_DOP_INFO: "",
    UF_INVESTOR_CONFIRM: "",
    UF_SOURCE_INF_ID: "",
    UF_SOURCE_INF_TEXT: "",
    UF_IS_READ: "",
    UF_IS_BLOCK: "",
    UF_IS_ON_COMISSION: "",
    UF_FILE_NOTICE: "",
    ORG_INFO: {
      UF_ADR_KORESPONDENT: "",
      UF_CITY: "",
      UF_COMMENT: "",
      UF_DATE_REGISTER: "",
      UF_DIR_EMAIL1: "",
      UF_DIR_EMAIL2: "",
      UF_DIR_LAST_NAME: "",
      UF_DIR_NAME: "",
      UF_DIR_PHONE1: "",
      UF_DIR_PHONE2: "",
      UF_DIR_POSITION: "",
      UF_DIR_SECOND_NAME: "",
      UF_FACT_ADRESS: "",
      UF_FULLNAME: "",
      UF_HOME: "",
      UF_INN: "",
      UF_IS_DELETE: "",
      UF_IS_LIZING: "",
      UF_IS_OPK: "",
      UF_IS_PRIORITY_PRO: "",
      UF_IS_SMALL_ENT: "",
      UF_KPP: "",
      UF_NAME: "",
      UF_OFFICE_NUMBER: "",
      UF_OGRN: "",
      UF_ORG_FORM_ID: "",
      UF_POST_INDEX: "",
      UF_REGION_ID: "",
      UF_STREET: "",
      UF_WEB_SITE: ""
    }
  },
  projectMainInfo: {
    ID: "",
    UF_NUMBER: "",
    UF_NAME: "",
    UF_COMPANY_ID: 0
  },
  projects: {
    counts: 0,
    items: []
  },
  userProjectProgrammes: [],
  isLoading: true,
  isProjectLoading: false,
  isProjectLoadingError: false,
  addProjectError: "",
  saveProjectErrors: [],
  saveProjectSaved: false,
  showTotalMessageSaved: true,
  projectStatusHistory: [],
  versionSave: 1,
  textSaveTotalVersion2: "",
  textSaveTotalOkVersion2: ""
};

const getters = {
  projects(state) {
    return state.projects;
  },
  isLoading(state) {
    return state.isLoading;
  },
  isProjectLoadingError(state) {
    return state.isProjectLoadingError;
  },
  isProjectLoading(state) {
    return state.isProjectLoading;
  },
  userProjectProgrammes(state) {
    return state.userProjectProgrammes;
  },
  addProjectError(state) {
    return state.addProjectError;
  },
  saveProjectErrors(state) {
    return state.saveProjectErrors;
  },
  project(state) {
    return state.project;
  },
  projectMainInfo(state) {
    return state.projectMainInfo;
  },
  projectStatusHistory(state) {
    return state.projectStatusHistory;
  },
  saveProjectSaved(state) {
    return state.saveProjectSaved;
  },
  showTotalMessageSaved(state) {
    return state.showTotalMessageSaved;
  },
  versionSave(state) {
    return state.versionSave;
  },
  textSaveTotalVersion2(state) {
    return state.textSaveTotalVersion2;
  },
  textSaveTotalOkVersion2(state) {
    return state.textSaveTotalOkVersion2;
  }
};

const actions = {
  [FETCH_PROJECT]({ commit }, slug) {
    commit(FETCH_PROJECT_START);
    return ProjectsService.get(slug)
      .then(({ data }) => {
        commit(FETCH_PROJECT_END, data);
      })
      .catch(error => {
        commit(FETCH_PROJECTS_ERROR);
        console.log(error);
        //throw new Error(error);
      });
  },
  [FETCH_PROJECT_MAIN_INFO]({ commit }, slug) {
    commit(FETCH_PROJECT_MAIN_INFO_START);
    return ProjectsService.getMainInfo(slug)
      .then(({ data }) => {
        commit(FETCH_PROJECT_MAIN_INFO_END, data);
      })
      .catch(error => {
        commit(FETCH_PROJECTS_MAIN_INFO_ERROR);
        console.log(error);
        //throw new Error(error);
      });
  },
  [FETCH_PROJECTS]({ commit }, params) {
    commit(FETCH_PROJECTS_START);
    return ProjectsService.list(params.type, params)
      .then(({ data }) => {
        commit(FETCH_PROJECTS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  [FETCH_PROJECT_TYPES]() {
    return ProjectsService.userProgrammes({})
      .then(({ data }) => {
        state.userProjectProgrammes = data;
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  [FETCH_PROJECT_HISTORY]() {
    return ProjectsService.getStatusHistory(state.project.ID)
      .then(({ data }) => {
        state.projectStatusHistory = data;
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  [ADD_PROJECT]({ commit }, params) {
    commit(ADD_PROJECT_START);
    return ProjectsService.addProject(params)
      .then(({ data }) => {
        commit(ADD_PROJECT_END, data);
      })
      .catch(({ response }) => {
        commit(ADD_PROJECT_ERROR, response.data);
      });
  },
  [SAVE_PROJECT]({ commit }, params) {
    commit(SAVE_PROJECT_START);
    return ProjectsService.saveProject(params, params.step)
      .then(({ data }) => {
        commit(SAVE_PROJECT_END, data);
      })
      .catch(({ response }) => {
        commit(SAVE_PROJECT_ERROR, response.data);
      });
  },
  [SEND_PROJECT]({ commit }, params) {
    commit(SAVE_PROJECT_START);
    return ProjectsService.sendProject(params)
      .then(({ data }) => {
        commit(SAVE_PROJECT_END, data);
      })
      .catch(({ response }) => {
        commit(SAVE_PROJECT_ERROR, response.data);
      });
  },
  [RESEND_PROJECT]({ commit }, params) {
    commit(SAVE_PROJECT_START);
    return ProjectsService.reSendProject(params)
      .then(({ data }) => {
        commit(SAVE_PROJECT_END, data);
      })
      .catch(({ response }) => {
        commit(SAVE_PROJECT_ERROR, response.data);
      });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_PROJECTS_START](state) {
    state.isLoading = true;
  },
  [FETCH_PROJECTS_END](state, projects) {
    state.projects = projects;
    state.isLoading = false;
  },
  [FETCH_PROJECTS_ERROR](state) {
    state.isLoading = false;
    state.isProjectLoadingError = true;
  },
  [UPDATE_PROJECT_IN_LIST](state, data) {
    state.projects = state.projects.map(projects => {
      if (projects.slug !== data.slug) {
        return projects;
      }
      return projects;
    });
  },
  [ADD_PROJECT_START](state) {
    state.isProjectLoading = true;
  },
  [ADD_PROJECT_END](state, data) {
    state.project = data;
    state.isProjectLoading = false;
  },
  [ADD_PROJECT_ERROR](state, data) {
    state.isProjectLoading = false;
    state.addProjectError = data["text-error"];
    throw new Error(state.addProjectError);
  },
  [SAVE_PROJECT_START](state) {
    state.isProjectLoading = true;
    state.saveProjectErrors = [];
  },
  [SAVE_PROJECT_END](state, data) {
    state.isProjectLoading = false;
    if (data.error === true) {
      state.saveProjectErrors = data.errorArr;
    }
    state.saveProjectSaved = data.saveProject;
    state.showTotalMessageSaved = data.showTotalMessage;
    state.versionSave = data.versionSave;
    state.textSaveTotalVersion2 = data.textSaveTotalVersion2;
    state.textSaveTotalOkVersion2 = data.textSaveTotalOkVersion2;
  },
  [SAVE_PROJECT_ERROR](state, data) {
    console.log(data);
  },
  [FETCH_PROJECT_END](state, project) {
    if (project.UF_EXPORT_COUNTRY_ID === null) {
      project.UF_EXPORT_COUNTRY_ID = [];
    }
    state.isLoading = false;
    state.project = project;
    const tutorialKeys = {};
    Object.keys({
      ...project.UF_HELP.SCENARIO.STEP1,
      ...project.UF_HELP.SCENARIO.STEP2,
      ...project.UF_HELP.SCENARIO.STEP3
    }).forEach(el => {
      if (el === "MAIN_COVER_HELP" || el === "ZALOGI_HELP") {
        Object.keys(project.UF_HELP.SCENARIO.STEP3[el]).forEach(subElement => {
          tutorialKeys[`${el}_${subElement}`] = false;
        });
      } else if (el === "OTHER_FINANCE") {
        Object.keys(project.UF_HELP.SCENARIO.STEP2[el]).forEach(subElement => {
          tutorialKeys[`${el}_${subElement}`] = false;
        });
      } else {
        tutorialKeys[el] = false;
      }
    });
    state.project = {
      ...state.project,
      ...tutorialKeys
    };
    const arr2 = [];
    const arr3 = [];
    state.project.UF_HELP.SCENARIO.STEP2_ARR.forEach(element => {
      if (element === "OTHER_FINANCE") {
        Object.keys(state.project.UF_HELP.SCENARIO.STEP2[element]).forEach(
          subElement => {
            arr2.push(`${element}_${subElement}`);
          }
        );
      } else {
        arr2.push(element);
      }
    });
    state.project.UF_HELP.SCENARIO.STEP3_ARR.forEach(element => {
      if (element === "MAIN_COVER_HELP" || element === "ZALOGI_HELP") {
        Object.keys(state.project.UF_HELP.SCENARIO.STEP3[element]).forEach(
          subElement => {
            arr3.push(`${element}_${subElement}`);
          }
        );
      } else {
        arr3.push(element);
      }
    });
    state.project.ARR1 = [...state.project.UF_HELP.SCENARIO.STEP1_ARR];
    state.project.ARR2 = [...arr2];
    state.project.ARR3 = [...arr3];
    return project;
  },
  [FETCH_PROJECT_MAIN_INFO_END](state, projectMaininfo) {
       state.projectMainInfo = projectMaininfo;
      return projectMainInfo;
    },
};

export default {
  state,
  getters,
  actions,
  mutations
};
